/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  shared app action constants
 */

export const REQUEUE = '@@nr/app/REQUEUE'
